import * as React from 'react';
import styled from 'styled-components';
import { TooltipTheOneWrapper } from '../TooltipTheOne';
import { colors } from '../colors/color';

type SegmentProps = {
    color:string,
    toolTip?:React.ReactNode,
    onClick?:()=>void
}

type SegmentBarProps = {
    height?:number,
    selectionPxIncrease?:number,
    emptyColor?:string,
    gapPx?:number,
    totalSegments:number,
    selectedIndex?:number,
    minWidthPx?:number,
    segments:SegmentProps[]
}
export function SegmentBar(props:SegmentBarProps):JSX.Element
{
    const bgColor = props.emptyColor || '#ddd';

    const paintSegments:SegmentProps[] = props.segments.map(s => ({color:s.color, onClick:s.onClick, toolTip:s.toolTip}));
    const missing = props.totalSegments - paintSegments.length;
    for (let i = 0; i < missing; i++) {
        paintSegments.push({color:bgColor});
    }

    const totalHeight = props.height || 20;
    const unselectedHeight = totalHeight - (props.selectionPxIncrease || 4);

    return (
        <StyledContainer height={`${totalHeight}px`} gapPx={props.gapPx || 4} minWidthPx={props.minWidthPx || 0}>
            {paintSegments.map((s,i) => {

                let appliedColor = s.color;
                if(i === props.selectedIndex)
                    appliedColor = colors.graphs.segmentBar.selected;
                
                const segment = 
                    <StyledSegment key={i} color={appliedColor} hasOnClick={!!s.onClick} height={i === props.selectedIndex ? totalHeight : unselectedHeight}
                        onClick={s?.onClick}
                     />

                return (
                    s.toolTip ?
                        <TooltipTheOneWrapper key={i} tooltipContent={s.toolTip} flex="1 0 0" display="flex">
                            {segment}
                        </TooltipTheOneWrapper>
                    :
                        segment
                );
            })}
        </StyledContainer>
    );
}

const StyledContainer = styled.div<{height:string, gapPx:number, minWidthPx:number}>`
    display: flex;
    flex: 1 0 0;
    justify-content: stretch;
    align-items: center;
    gap:${props => props.gapPx}px;
    height:${props => props.height};
    min-width:${props => props.minWidthPx}px;
`;

const StyledSegment = styled.div<{color:string, height:number, hasOnClick:boolean}>`
    display: flex;
    height:${props => props.height}px;
    background-color: ${props => props.color};
    box-sizing: border-box;
    border-radius: 0px;
    flex: 1 1 10px;
    ${props => props.hasOnClick &&
        'cursor:pointer;'
    }
`;